var React = require('react');

function NavMenuCloseIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.06 2.94a1.5 1.5 0 1 0-2.12 2.12L9.878 12l-6.94 6.94a1.5 1.5 0 0 0 2.122 2.12L12 14.122l6.94 6.94a1.5 1.5 0 0 0 2.12-2.122L14.122 12l6.94-6.94a1.5 1.5 0 0 0-2.122-2.12L12 9.878l-6.94-6.94z","fill":"#fff"}));
}

NavMenuCloseIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = NavMenuCloseIcon;

NavMenuCloseIcon.default = NavMenuCloseIcon;
